// mixin.js
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import { user } from '@/plugins/papybase/papybaseInit';
import { MUTATE_USER } from '@/store/modules/auth';
import { Component, Mixins } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class UserIntegrationMixin extends Mixins(GAErrorEvent) {
    public async integrateUserFromBackEndToLocalStorage() {
        try {
            const theUser = await user.getMyProfile(this.jwt);
            this.$store.commit(MUTATE_USER, theUser);
        } catch (error) {
            this.errorEvent('getMyProfile', error);
            throw new Error(error);
        }
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }
}
